import React, { FC } from 'react';
import cls from 'classnames';

export type IconTypes =
  | 'arrow_back'
  | 'burger'
  | 'calendar'
  | 'circle_done'
  | 'copy'
  | 'done'
  | 'exit'
  | 'external_link'
  | 'file_new'
  | 'folder_open'
  | 'help'
  | 'mail_open'
  | 'mail'
  | 'close'
  | 'refresh'
  | 'arrow_right'
  | 'user'
  | 'twitter'
  | 'discord'
  | 'wallet'
  | 'search'
  | 'info_square'
  | 'x';

export interface IIcon extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLElement>, HTMLElement> {
  color?: string;
  icon: IconTypes;
  className?: string;
  style?: React.CSSProperties;
  onClick?: () => void;
}

export const Icon: FC<IIcon> = ({ icon, onClick, className, ...props }) => {
  return <i className={cls(`icon icon-${icon}`, icon, className)} onClick={onClick} {...props} />;
};
